import { createAction, props } from '@ngrx/store';

export const setMultipleUpdate = createAction('[Bulk] multiple update', props<{ multipleData: any }>());
export const setData = createAction('[Bulk] set data', props<{ data: any }>());
export const setMultipleUpdateCustomization = createAction('[Bulk] multiple update customization', props<{ multipleDataCustom: any }>());
export const setDataCustomization = createAction('[Bulk] set data customization', props<{ dataCustom: any }>());
export const reset = createAction('[Bulk] reset all data');
